import React from "react";
// import spinner from "images/spinner.gif";
import spinner from "images/color-spinner.gif";

const Spinner = () => (
  <div className="position-absolute d-flex justify-content-center align-items-center" style={{
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "rgba(0,0,0,0.2)",
      zIndex: 100
  }}>
    <img
      src={spinner}
      style={{
          width: 100,
          margin: "auto",
          display: "block"
      }}
      alt="Loading..."
    />
  </div>
);

export default Spinner;



// WEBPACK FOOTER //
// ./src/views/lib/components/Spinner.js